import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, TextField } from "@mui/material";
import { DialpadSettings } from "../../api";
import { PasswordField } from "../controls";

export interface DialpadSettingsControlProps {
  settings?: DialpadSettings;
  onChange: (settings: Partial<DialpadSettings>) => void;
}

export const DialpadSettingsControl = (props: DialpadSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">Dialpad settings</FormLabel>
      <FormGroup>
        <FormControlLabel label="Enabled" control={<Checkbox checked={settings?.enabled ?? false} onChange={(e, c) => onChange({ enabled: c })} />} />
        <TextField label="Email" variant="standard" value={settings?.email ?? ""} onChange={(e) => onChange({ email: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
        <TextField label="Department Name" variant="standard" value={settings?.department ?? ""} onChange={(e) => onChange({ department: e.target.value })} />
        <TextField label="Inbox Name" variant="standard" value={settings?.inbox ?? ""} onChange={(e) => onChange({ inbox: e.target.value })} />
      </FormGroup>
    </FormControl>
  );
};
